export const TextSize = {
	// Doesn't exist in Frisk, nor tailwind.
	// xxs: 'text-xxs',

	// Only exist in tailwind.
	xs: 'text-xs',

	// These exist in tailwind, but is overriden in Frisk (though with same result )
	sm: 'text-sm',
	md: 'text-md', // 1rem (16px)
	lg: 'text-lg', // 1.125rem (18px)

	// Only exist in tailwind.
	xl: 'text-xl', // 1.25rem (20px)

	// This exist in tailwind as text-2xl, but is overriden in Frisk (though with same result )
	xxl: 'text-xxl', // 1.5rem (24px)

	// Doesn't exist in Frisk, and is called text-3xl in tailwind.
	// xxxl: 'text-xxxl', // 1.875rem (30px)
	// '3xl': 'text-3xl', // TODO: Doesn't work, perhaps due to tailwind version?
	'3xl': 'text-[30px]',

	// Exist in frisk, but I don't really like the name, is the same as tailwinds text-4xl.
	// '36px': 'text-[36px]',
	'4xl': 'text-[36px]', // 2.25rem (36px)
	// '4xl': 'text-4xl', // TODO: Doesn't work, perhaps due to tailwind version?
} as const;


export const LineHeight = {
	// See frisk/_lacks.scss
	headings: 'leading-headings',
	normal: 'leading-normal',
	none: 'leading-none',
};


export const Weight = {
	bold: 'font-bold',
	'semiBold': 'font-semibold',
	normal: 'font-normal',
};
